import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput } from 'components';
import { CSVLink } from 'react-csv';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));
let csvData = [];
let users;
const Toolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  users = props.users;
  let a = props.a;
  csvData = [
    ["Name", "Email", "AUI ID", "Phone", "School", "Major", "Minor", "Status", "CV Link"],
  ];
  if(users) {
    users.map(user => {
      csvData.push([user.first_name + user.last_name, user.email, user.aui_id, user.phone_number, user.school, user.major, user.minor, user.is_alumni?'Alumni':'Student', user.cv_url])
    })
  }
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <span className={classes.spacer} />

        <CSVLink
          data={csvData}
          filename={"Selection.csv"}
          className="btn btn-primary"
          target="_blank"
        >
          <Button
            color="primary"
            variant="contained"
            className="float-right"
            style={{float: 'right'}}
          >
            Export
          </Button>
        </CSVLink>
      </div>
      <div className={classes.row}>
        <SearchInput
          disabled
          className={classes.searchInput}
          placeholder="Search user"
        />
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  users: PropTypes.array
};

export default Toolbar;
